import { FC } from 'react'

import styled from 'styled-components'

import SuccessIcon from 'src/Assets/Svg/pages-icons/Success.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { FullScreenModal } from 'src/Components/FullScreenModal'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { CrossSellSuccessBlock } from 'src/Components/CrossSellSuccessPopup'
import { getCrossSellIntroMessage } from 'src/Components/CrossSellSuccessPopup/helpers'
import { useSuccessPage } from 'src/Components/SuccessPage/useSuccessPage'
import { PaymentStateScreen } from 'src/Components/SuccessPage/PaymentStateScreen'

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 820px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 358px;
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 40px 16px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 600px;
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`
const IntroText = styled(Text)`
  margin-top: 16px;
`
const StyledSuccessIcon = styled(SuccessIcon)`
  color: ${({ theme }) => theme.color.brandGreen};
`

export const SuccessAdsCampaignPaid: FC = () => {
  const {
    isLoading,
    isTimedOut,
    isFailed,
    isRetrying,
    isSuccessPageVisible,
    title,
    text,
    onCampaignsButtonClick,
    onBalanceButtonClick,
    onTryAnotherMethodClick,
  } = useSuccessPage({ platformName: CampaignPlatformTypeEnum.META })

  if (!isSuccessPageVisible) {
    return null
  }

  if (isLoading || isTimedOut || isFailed) {
    return (
      <PaymentStateScreen
        title={title}
        text={text}
        isLoading={isLoading}
        isFailed={isFailed}
        isRetrying={isRetrying}
        onCampaignsButtonClick={onCampaignsButtonClick}
        onBalanceButtonClick={onBalanceButtonClick}
        onTryAnotherMethodClick={onTryAnotherMethodClick}
      />
    )
  }

  return (
    <FullScreenModal open>
      <Wrapper>
        <Container>
          <StyledSuccessIcon width={40} height={40} />
          <TextContainer>
            <Title>{title}</Title>
            <Text>
              A dedicated campaign manager will set up and launch your campaign
              within 24-72 hours.
            </Text>
            <IntroText>
              {getCrossSellIntroMessage(CampaignPlatformTypeEnum.META)}
            </IntroText>
          </TextContainer>

          <CrossSellSuccessBlock
            currentPlatform={CampaignPlatformTypeEnum.META}
          />

          <PrimaryDottedButton onClick={onCampaignsButtonClick}>
            Back to Campaigns
          </PrimaryDottedButton>
        </Container>
      </Wrapper>
    </FullScreenModal>
  )
}
